import React, { createElement } from 'react';
import { mockRepublishedStories } from '../data/mockData';
import { ClockIcon, DownloadIcon } from 'lucide-react';
import Papa from 'papaparse';
export function RepublishedStories() {
  const handleDownloadCSV = () => {
    const csvData = mockRepublishedStories.map(story => ({
      'Story Title': story.storyTitle,
      'Republished Date': story.republishedAt,
      'Republished By': story.user,
      'Page Views': story.pageViews
    }));
    const csv = Papa.unparse(csvData);
    const blob = new Blob([csv], {
      type: 'text/csv;charset=utf-8;'
    });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `republished-stories-${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return <div className="space-y-8" data-id="element-350">
      {/* Header */}
      <div className="flex items-end justify-between" data-id="element-351">
        <div data-id="element-352">
          <h1 className="text-4xl font-bold text-display text-neutral-900 mb-2" data-id="element-353">
            Republished Stories
          </h1>
          <p className="text-lg text-neutral-600" data-id="element-354">
            View your content publishing history
          </p>
        </div>
        {mockRepublishedStories.length > 0 && <button onClick={handleDownloadCSV} className="flex items-center gap-2 px-6 py-3 text-white rounded-lg hover:shadow-md transition-all font-medium" style={{
        background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
      }} data-id="element-355">
            <DownloadIcon className="w-5 h-5" data-id="element-356" />
            Download Report as CSV
          </button>}
      </div>
      {mockRepublishedStories.length === 0 ? <div className="bg-white rounded-xl p-12 shadow-card border border-neutral-200 text-center" data-id="element-357">
          <ClockIcon className="w-16 h-16 text-neutral-300 mx-auto mb-4" data-id="element-358" />
          <h3 className="text-xl font-bold text-display text-neutral-900 mb-2" data-id="element-359">
            No Republished Stories Yet
          </h3>
          <p className="text-neutral-600" data-id="element-360">
            Visit the Explore page to discover and republish stories from the
            network
          </p>
        </div> : <div className="bg-white rounded-xl shadow-card border border-neutral-200 overflow-hidden" data-id="element-361">
          {/* Table Header */}
          <div className="grid grid-cols-[2fr_2fr_1fr_1fr] gap-6 px-8 py-4 bg-neutral-50 border-b border-neutral-200" data-id="element-362">
            <div className="text-sm font-semibold text-neutral-700" data-id="element-363">
              Story Title
            </div>
            <div className="text-sm font-semibold text-neutral-700" data-id="element-364">
              Republished Date
            </div>
            <div className="text-sm font-semibold text-neutral-700" data-id="element-365">
              Republished By
            </div>
            <div className="text-sm font-semibold text-neutral-700" data-id="element-366">
              Page Views
            </div>
          </div>
          {/* Table Body */}
          <div className="divide-y divide-neutral-200" data-id="element-367">
            {mockRepublishedStories.map(story => <div key={story.id} className="grid grid-cols-[2fr_2fr_1fr_1fr] gap-6 px-8 py-5 hover:bg-neutral-50 transition-colors" data-id="element-368">
                <div data-id="element-369">
                  <p className="font-medium text-neutral-900" data-id="element-370">
                    {story.storyTitle}
                  </p>
                </div>
                <div data-id="element-371">
                  <p className="text-neutral-600" data-id="element-372">{story.republishedAt}</p>
                </div>
                <div data-id="element-373">
                  <p className="text-neutral-600" data-id="element-374">{story.user}</p>
                </div>
                <div data-id="element-375">
                  <p className="font-semibold" style={{
              color: '#0289BB'
            }} data-id="element-376">
                    {story.pageViews.toLocaleString()}
                  </p>
                </div>
              </div>)}
          </div>
        </div>}
    </div>;
}